import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms the given value into an valid input type
 */
@Pipe({
  name: 'controlNameToHuman'
})
export class ControlNameToHumanPipe implements PipeTransform {
  transform(value: any): string {
    switch (value) {
      case 'old_pass':
        return 'old password';
      case 'pass':
        return 'password';
      case 'pass_conf':
        return 'password confirmation';
      default:
        return value;
    }
  }
}
